import type { SignUpLead } from '../../domain/entities/lead.entity';

export interface LeadDatasource {
  acceptLatest(lead: SignUpLead): Promise<void>;
}

export class LeadRepositoryImpl {
  private readonly datasource: LeadDatasource;

  constructor(datasource: LeadDatasource) {
    this.datasource = datasource;
  }

  /**
   * Registra o aceite da Política de Privacidade.
   *
   * **Nunca rejeita.** O serviço de políticas é lateral ao cadastro: fora do
   * ar, a pessoa continua tendo que conseguir criar a conta.
   *
   * **O log leva só a mensagem**, nunca o erro: o erro do axios carrega a
   * requisição, com e-mail, nome e telefone no corpo (LGPD — ver o CLAUDE.md).
   */
  async captureSignUp(lead: SignUpLead): Promise<void> {
    try {
      await this.datasource.acceptLatest(lead);
    } catch {
      console.error('[lead] falha ao registrar o aceite da política');
    }
  }
}
